import { SelectionConfigTable } from './SelectionConfigTable';
import { Box, Button, Typography } from '@mui/material';

const GenAlgSelectionConfigs = () => {

    const CreateSelectionConfigButton = () =>
        <Button
            sx={{ marginLeft: '20px' }}
            variant="contained"
            href={"create-gen-alg-selection-config"}
        >
            CREATE SELECTION CONFIG
        </Button>
    return (
        <div>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
                <Box>
                    <Typography variant="h6">Selection Configs</Typography>
                </Box>
                <Box>
                    <CreateSelectionConfigButton />
                </Box>
            </Box>
            <SelectionConfigTable />
        </div>
    )
}

export default GenAlgSelectionConfigs;